/* eslint-disable pii/no-phone-number */
import React from "react";
import PropTypes from "prop-types";
import { CheckboxField } from "cxa-form-field";
import { validateRequired } from "../validation";

const Declaration = ({ isReadOnly, renderValue }) => (
  <table className="normalPadded" style={{ borderCollapse: "collapse", width: "100%" }}>
    <tbody>
      <tr>
        <td style={{ paddingLeft: 0 }} colSpan={11}>
          <div
            style={{
              fontWeight: "bold",
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            (E) DECLARATION
          </div>
          <div style={{ paddingBottom: 10 }}>
            I/We declare that all the information on this Application Form is true and complete to
            the best of my knowledge and understand that any misrepresentation or concealment of
            facts shall render the policy to be issued null and void. I agree that this application
            shall be the basis of the insurance coverage issued under the said Group Insurance
            Policy. I understand that the insurance coverage shall not become effective until it is
            accepted and confirmed in writing by Aviva Ltd.
          </div>
          <div style={{ paddingBottom: 10 }}>
            {[
              "I agree to inform Aviva Ltd if there is any change in the state ",
              "of my and/or my dependants' health/activities between the date ",
              "of this Health Declaration and the date full insurance ",
              "coverage is provided by Aviva Ltd to me and/or my ",
              "dependant(s). I understand that the terms of accepting me ",
              "and/or my dependant(s) as a risk for insurance coverage may ",
              "vary according to such information received.",
            ].join("")}
          </div>
          <div style={{ paddingBottom: 10 }}>
            I consent to Aviva Ltd seeking information from any doctor who has attended to me and/or
            my dependant(s) or from other insurance company to which I and/or my dependant(s) have
            at any time made a proposal for insurance and I authorise the giving of such
            information. I further authorise Aviva Ltd to give such information obtained or
            information contained herein for the purpose of obtaining insurance cover under the said
            Group Policy to the insurance intermediary / administrator of the said Group Insurance
            Policy.
          </div>
          <div style={{ paddingBottom: 10 }}>
            I/We am/are aware that the product I/We am/are applying for is authorised for sale in
            Singapore and I/we acknowledge that the laws and regulations applicable to my/our
            nationality and country of residence allows my/our purchase of this product. I/We
            understand that no liability can be accepted by Aviva for any legal consequences under
            the laws of other country or any tax implications that may arise in connection with
            my/our purchase of this product.
          </div>
          <div style={{ paddingBottom: 10, color: "#f00" }}>
            <span style={{ fontWeight: "bold" }}>
              Only applicable to Group Medical products for all voluntary and flexible benefits:
            </span>{" "}
            I/We confirm that I/we have received a copy of Your Guide to Health Insurance and
            Product Summary and have read and understood the contents of these two documents.
          </div>
          <br />
          <CheckboxField
            {...(isReadOnly ? { disabled: { isReadOnly }, checked: { isReadOnly } } : {})}
            validate={validateRequired}
            name="declaration"
            id="declaration"
          >
            <strong>I have read and accept this declaration</strong>
          </CheckboxField>
          <div style={{ paddingBottom: 10 }}>
            <center>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <span style={{ fontWeight: "bold" }}>
                        Health Declaration Form Completed On:
                      </span>
                    </td>
                    <td
                      style={{
                        borderBottom: "1px solid #000",
                        width: 200,
                      }}
                      id="RO_CompletedOn"
                    >
                      {renderValue({
                        fieldName: "CompletedOn",
                        fieldFormat: "date",
                        dateFormat: "D MMM YYYY",
                      })}
                    </td>
                    <td>by</td>
                    <td
                      style={{
                        borderBottom: "1px solid #000",
                        width: 200,
                      }}
                      id="RO_CompletedBy"
                    >
                      {renderValue({
                        fieldName: "CompletedBy",
                        fieldFormat: "text",
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </div>
          <div style={{ textAlign: "center", paddingTop: 30 }}>
            Aviva Ltd&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4 Shenton Way #01-01 SGX Centre 2, Singapore
            068807&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Tel: (65) 6827 7988&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Fax: (65) 6827 7401&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <b>www.aviva.com.sg</b>
            <br />
            Company Reg. No.: 196900499K&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; GST Reg. No.: MR-8500166-8
          </div>
        </td>
      </tr>
    </tbody>
  </table>
);

Declaration.propTypes = {
  isReadOnly: PropTypes.bool.isRequired,
  renderValue: PropTypes.func.isRequired,
};

export default Declaration;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201910/Declaration.js